export const PIN_CATEGORIES = ['info', 'drink_food', 'partners', 'offscreen'];
